export const GET_CUSTOMER_ORDERS = "GET_CUSTOMER_ORDERS";
export const GET_CUSTOMER_ORDER_KITS  = "GET_CUSTOMER_ORDER_KITS";
export const SWITCH_ORDER_FORM = "SWITCH_ORDER_FORM";